module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/Content#cd4ds3",
      "id": "nhjgb89"
    }
  }, [_vm._v("KEY")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "small"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "17%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "83%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("BW-ST:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Broken Wings")]), _vm._v(" by Kahlil Gibran, in "), _c('i', [_vm._v("A Second Treasury of Kahlil Gibran,")]), _vm._v(" trans. by Anthony R. Ferris, Citadel Press, 1962.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("KG-P:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Kahlil Gibran: A Biography")]), _vm._v(" by Michael Naimy, in "), _c('i', [_vm._v("The Parables of Gibran")]), _vm._v(" by Annie Salem Otto, Citadel Press, 1963.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("P:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("The Procession")]), _vm._v(" by Kahlil Gibran, trans. by George Kheirallah, Philosophical Library, 1958.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("MS:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Mirrors of the Soul, Kahlil Gibran,")]), _vm._v(" by Joseph Sheban, Philosophical Library, 1965.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("S:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("In conversation and correspondence.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("SH-P:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Secrets of the Heart")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("The Parables of Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("SH-T:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Secrets of the Heart")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("A Treasury of Kahlil Gibran,")]), _vm._v(" trans. by Anthony Rizcallah Ferris, edited by Martin L. Wolf, Citadel Press, 1947.")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("SP-P:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Kahlil Gibran: A Self Portrait,")]), _vm._v(" trans. by Anthony R. Ferris, in "), _c('i', [_vm._v("The Parables of Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("SR-T:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Spirits Rebellious")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("A Treasury of Kahlil Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("T:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("A Treasury of Kahlil Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("TL-T:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("Tears and Laughter")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("A Treasury of Kahlil Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("VM-V:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("The Voice of the Master")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("The Parables of Gibran.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("WM-ST:")]), _vm._v(" "), _c('td', {
    staticClass: "hang",
    attrs: {
      "valign": "top"
    }
  }, [_c('i', [_vm._v("The Words of the Master")]), _vm._v(" by Kahlil Gibran in "), _c('i', [_vm._v("A Second Treasury of Kahlil Gibran.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f68cc350","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/key.vue
// module id = 72
// module chunks = 0